import React from 'react';
import { HashRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { SessionRealtimeProvider } from './context/SessionRealtimeContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { PlayerLayout } from './layouts/PlayerLayout';
import { AdminLayout } from './layouts/AdminLayout';
import { AdminRoute } from './guards/AdminRoute';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { GameSettingsPage } from './pages/admin/GameSettingsPage';
import { QuestionSetsPage } from './pages/admin/QuestionSetsPage';
import { SavedQuizzesPage } from './pages/admin/SavedQuizzesPage';
import { GlobalSettingsPage } from './pages/admin/GlobalSettingsPage';
import { PlayerFlowPage } from './pages/player/PlayerFlowPage';
import { LocalizationProvider } from './localization/LocalizationProvider';

function PlayerApp() {
  return (
    <SessionRealtimeProvider>
      <PlayerLayout>
        <PlayerFlowPage />
      </PlayerLayout>
    </SessionRealtimeProvider>
  );
}

function AdminApp() {
  return <Outlet />;
}

export default function App() {
  return (
    <LocalizationProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/igra" replace />} />
          <Route path="/igra" element={<PlayerApp />} />

          <Route path="/admin" element={<AdminAuthProvider><AdminApp /></AdminAuthProvider>}>
            <Route path="login" element={<AdminLoginPage />} />
            <Route element={<AdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboardPage />} />
                <Route path="postavke-igre" element={<GameSettingsPage />} />
                <Route path="pitanja" element={<QuestionSetsPage />} />
                <Route path="kvizovi" element={<SavedQuizzesPage />} />
                <Route path="opce-postavke" element={<GlobalSettingsPage />} />
                <Route index element={<Navigate to="dashboard" replace />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/igra" replace />} />
        </Routes>
      </HashRouter>
    </LocalizationProvider>
  );
}
